/** Copy and formatting for the account panel's log-buffer line (components/AccountModal.jsx). */

/**
 * Clears what the next bug report attaches; what was streamed stays in telemetry.
 */
export const RESET_LOG_TITLE =
  "Clear the ui and trace buffers that go into the next bug report. Events already " +
  "streamed to telemetry are not deleted (the bug's session timeline still shows them).";

/** `ui 123 · trace 456 · streamed 789`; streamed is — while the stream flag is off. */
export function formatLogCounts({ ui, trace, streamed }) {
  return `ui ${ui} · trace ${trace} · streamed ${streamed == null ? "—" : streamed}`;
}
